import contact from './contact'
import ticket from './ticket'
import faq from './faq'
import tutorial from './tutorial'

export default {
  name: 'Crm',
  path: 'crm',
  meta: {
    label: 'crm',
    auth: 'crm'
  },
  component: {
    name: 'Crm',
    render(c) {
      return c('router-view')
    }
  },
  children: [contact, ticket, faq, tutorial]
}
